// daire-detay.js
// Reservation calendar için gelişmiş Lightpick entegrasyonu

// Ekrandaki metinler dil dosyasından gelir (modals.liquid reservationCalendar →
// window.translations.reservation_calendar); köprü yoksa Türkçe yedek.
function reservationCalendarText(key, fallback) {
    const value = window.translations?.reservation_calendar?.[key];
    return typeof value === 'string' && value !== '' ? value : fallback;
}
let picker = null;
let selectedStart = null;
let selectedEnd = null;

// Mobil kontrol fonksiyonu
function isMobile() {
    return window.innerWidth <= 768;
}

// Giriş (check-in) tarihi yalnızca daire boşaldığı günden itibaren +7 gün içinde
// seçilebilir. Kiralama süresine göre izin verilen tampon (WhatsApp isteği):
//   100 gün – 6 ay  : 3 gün
//   6 ay – 9 ay     : 5 gün
//   9 ay – 12 ay    : 7 gün
// Hata göstermek yerine geçersiz günler baştan kapatılır: giriş müsaitlikten kaç gün
// sonraysa, çıkış takvimindeki en kısa süre o tampona izin veren süreye uzatılır
// (ör. +5. günde giriş → çıkış en erken 6 ay + 1 gün sonrası).
var MAX_START_BUFFER_DAYS = 7;

function minEndDateForStart(startM, availableStartM, minDays) {
    var start = moment(startM).startOf('day');
    var offset = start.diff(moment(availableStartM).startOf('day'), 'days');
    var minEnd = start.clone().add(minDays, 'days');
    if (offset > 5) {
        minEnd = moment.max(minEnd, start.clone().add(9, 'months').add(1, 'day'));
    } else if (offset > 3) {
        minEnd = moment.max(minEnd, start.clone().add(6, 'months').add(1, 'day'));
    }
    return minEnd;
}

// Takvim üstündeki not: neden yalnız birkaç günün seçilebildiğini müşteriye açıklar
// (daire boşaldıktan sonra yeni kiracı için en fazla 3/5/7 gün bekletilebilir).
function renderStartWindowNote(startM, endM) {
    const box = document.getElementById('start-window-note');
    if (!box) return;
    const textEl = box.querySelector('[data-start-window-note]');
    const detailEl = box.querySelector('[data-start-window-note-detail]');
    const lang = (document.documentElement.lang || 'tr').slice(0, 2) === 'en' ? 'en' : 'tr';
    const s = moment(startM).locale(lang);
    const e = moment(endM).locale(lang);
    const fmt = lang === 'en' ? 'MMMM D' : 'D MMMM';
    let range;
    if (s.isSame(e, 'month')) {
        range = lang === 'en' ? `${s.format('MMMM D')}–${e.format('D')}` : `${s.format('D')}–${e.format('D MMMM')}`;
    } else {
        range = `${s.format(fmt)} – ${e.format(fmt)}`;
    }
    const values = { __AVAIL__: s.format(fmt), __RANGE__: range };
    const template = reservationCalendarText('start_window_note',
        'Daireler boşaldıktan sonra yeni kiracıları için yalnızca birkaç gün bekletilebildiğinden, bu daire için giriş tarihini __RANGE__ arasında seçebilirsiniz.');

    if (textEl) {
        textEl.replaceChildren(...template.split(/(__AVAIL__|__RANGE__)/).map(function (part) {
            if (!values[part]) return document.createTextNode(part);
            const strong = document.createElement('strong');
            strong.textContent = values[part];
            return strong;
        }));
    }
    if (detailEl) {
        detailEl.textContent = reservationCalendarText('start_window_note_detail',
            'Bekleme süresi kiralama süresine göre değişir: 100 gün–6 ay için 3 gün, 6–9 ay için 5 gün, 9–12 ay için 7 gün. Daha geç bir giriş seçtiğinizde kısa kiralama süreleri kapanır.');
    }
    box.hidden = false;
}

function getReservationWindow(maxMonths) {
    const tomorrow = moment().add(1, 'day').startOf('day');
    const availableDateRaw = window.erraReservation && window.erraReservation.availableDate;
    const availableDate = availableDateRaw ? moment(availableDateRaw, 'YYYY-MM-DD', true) : null;
    const reservationStartDate = availableDate && availableDate.isValid() && availableDate.isAfter(tomorrow, 'day')
        ? availableDate.clone().startOf('day')
        : tomorrow.clone();

    return {
        startDate: reservationStartDate,
        maxDate: reservationStartDate.clone().add(maxMonths, 'months')
    };
}

document.addEventListener('DOMContentLoaded', function () {
    const minDays = 100;
    const maxMonths = 12;
    const reservationWindow = getReservationWindow(maxMonths);
    const reservationStartDate = reservationWindow.startDate;
    const reservationMaxDate = reservationWindow.maxDate;
    // Giriş tarihi seçim penceresinin üst sınırı: müsaitlik + en geniş tampon (7 gün).
    const startWindowMax = reservationStartDate.clone().add(MAX_START_BUFFER_DAYS, 'days');
    const minEndFor = (startM) => minEndDateForStart(startM, reservationStartDate, minDays);
    const firstVisibleMonth = reservationStartDate.clone().startOf('month');
    const lastVisibleMonth = reservationMaxDate.clone().startOf('month');

    const moveInDisplay = document.getElementById('move-in-display');
    const moveOutDisplay = document.getElementById('move-out-display');
    const quickDatePicker = document.getElementById('quick-date-picker');
    const calendarContainer = document.getElementById('calendar-container');

    if (!quickDatePicker || !calendarContainer) return;

    renderStartWindowNote(reservationStartDate, startWindowMax);

    // MOBİL: Kendi takvim gridini oluştur
    if (isMobile()) {
        let scrollContainer = document.getElementById('mobile-calendar-scroll-container');
        if (!scrollContainer) {
            scrollContainer = document.createElement('div');
            scrollContainer.id = 'mobile-calendar-scroll-container';
            scrollContainer.style.maxHeight = '60vh';
            scrollContainer.style.overflowY = 'auto';
            scrollContainer.style.width = '100%';
            calendarContainer.parentNode.insertBefore(scrollContainer, calendarContainer);
            scrollContainer.appendChild(calendarContainer);
        }
        calendarContainer.innerHTML = '';
        
        const dayNamesHeader = document.createElement('div');
        dayNamesHeader.className = 'daire-detay-calendar-day-names-header';
        const dayNames = reservationCalendarText('weekday_initials', 'P,P,S,Ç,P,C,C').split(',');
        dayNames.forEach(function (name) {
            const dayName = document.createElement('div');
            dayName.className = 'daire-detay-calendar-day-name';
            dayName.textContent = name;
            dayNamesHeader.appendChild(dayName);
        });
        calendarContainer.appendChild(dayNamesHeader);

        const monthsToRender = lastVisibleMonth.diff(firstVisibleMonth, 'months') + 1;
        for (let i = 0; i < monthsToRender; i++) {
            const monthDate = firstVisibleMonth.clone().add(i, 'months');
            renderMobileMonth(monthDate, calendarContainer, false);
        }

        function renderMobileMonth(monthDate, container, isFirstMonth) {
            const monthContainer = document.createElement('div');
            monthContainer.className = 'daire-detay-calendar-month';
            monthContainer.dataset.month = monthDate.format('YYYY-MM');

            const monthTitle = document.createElement('div');
            monthTitle.className = 'daire-detay-calendar-month-title';
            monthTitle.textContent = monthDate.locale(document.documentElement.lang || 'tr').format('MMMM YYYY');
            monthContainer.appendChild(monthTitle);

            const grid = document.createElement('div');
            grid.className = 'daire-detay-calendar-grid';

            const startOfMonth = monthDate.clone().startOf('month');
            const endOfMonth = monthDate.clone().endOf('month');
            const startDay = startOfMonth.day();
            
            for (let i = 0; i < startDay; i++) {
                const emptyCell = document.createElement('div');
                emptyCell.className = 'daire-detay-calendar-day disabled';
                grid.appendChild(emptyCell);
            }

            const daysInMonth = endOfMonth.date();
            for (let day = 1; day <= daysInMonth; day++) {
                const dayDate = monthDate.clone().date(day);
                const dayCell = document.createElement('div');
                dayCell.className = 'daire-detay-calendar-day';
                dayCell.textContent = day;
                dayCell.dataset.date = dayDate.format('YYYY-MM-DD');
                dayCell.dataset.day = day; // data-day attribute ekle
                dayCell.dataset.container = 'mobile';

                if (dayDate.isBefore(reservationStartDate, 'day') || dayDate.isAfter(reservationMaxDate, 'day')) {
                    dayCell.classList.add('disabled');
                }

                grid.appendChild(dayCell);
            }

            monthContainer.appendChild(grid);
            container.appendChild(monthContainer);
        }

        let isLoadingMore = false;
        scrollContainer.addEventListener('scroll', function () {
            const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
            if (scrollHeight - scrollTop - clientHeight < 200 && !isLoadingMore) {
                isLoadingMore = true;
                const lastMonth = calendarContainer.querySelector('.daire-detay-calendar-month:last-child');
                if (lastMonth) {
                    const lastMonthDate = moment(lastMonth.dataset.month, 'YYYY-MM');
                    for (let i = 1; i <= 3; i++) {
                        const nextMonth = lastMonthDate.clone().add(i, 'months');
                        if (nextMonth.isAfter(lastVisibleMonth, 'month')) {
                            break;
                        }
                        renderMobileMonth(nextMonth, calendarContainer, false);
                    }
                }
                setTimeout(function () { isLoadingMore = false; }, 100);
            }
        });

        // Mobilde gün seçimi ve inputa yazma
        let mobileSelectedStart = null;
        let mobileSelectedEnd = null;

        const mobileDayCells = () => calendarContainer.querySelectorAll('.daire-detay-calendar-day[data-date]');

        // Giriş seçim aşaması: yalnızca [müsaitlik, müsaitlik + 7 gün] tıklanabilir.
        function applyMobileStartPhase() {
            mobileDayCells().forEach(function (el) {
                if (el.classList.contains('disabled')) return;
                const d = moment(el.dataset.date, 'YYYY-MM-DD');
                el.classList.toggle('temp-disabled', d.isAfter(startWindowMax, 'day'));
            });
        }

        // Çıkış seçim aşaması: süre tamponuna göre en erken çıkış .. +12 ay. Giriş penceresi
        // açık kalır ki kullanıcı girişi değiştirebilsin.
        function applyMobileEndPhase(startM) {
            const minEndDate = minEndFor(startM);
            const maxEndDate = startM.clone().add(maxMonths, 'months');
            mobileDayCells().forEach(function (el) {
                if (el.classList.contains('disabled')) return;
                const d = moment(el.dataset.date, 'YYYY-MM-DD');
                const inStartWindow = !d.isAfter(startWindowMax, 'day');
                const validEnd = !d.isBefore(minEndDate, 'day') && !d.isAfter(maxEndDate, 'day');
                el.classList.toggle('temp-disabled', !(inStartWindow || validEnd));
            });
        }

        function clearMobileHighlight() {
            calendarContainer.querySelectorAll('.daire-detay-calendar-day.selected, .daire-detay-calendar-day.range, .daire-detay-calendar-day.range-start, .daire-detay-calendar-day.range-end').forEach(function (el) {
                el.classList.remove('selected', 'range', 'range-start', 'range-end');
            });
        }

        function resetMobileSelection() {
            mobileSelectedStart = null;
            mobileSelectedEnd = null;
            clearMobileHighlight();
            applyMobileStartPhase();
            if (moveInDisplay) moveInDisplay.textContent = reservationCalendarText('select_calendar', 'Takvim seçin');
            if (moveOutDisplay) moveOutDisplay.textContent = reservationCalendarText('select_calendar', 'Takvim seçin');
            if (quickDatePicker) quickDatePicker.value = '';
        }
        window.__resetMobileReservation = resetMobileSelection;

        function startMobileSelection(dayCell, clickedDate) {
            mobileSelectedStart = clickedDate;
            mobileSelectedEnd = null;
            selectedStart = clickedDate;
            selectedEnd = null;

            clearMobileHighlight();
            dayCell.classList.add('selected');

            if (moveInDisplay) moveInDisplay.textContent = clickedDate.format('D MMM YYYY');
            if (moveOutDisplay) moveOutDisplay.textContent = reservationCalendarText('select_move_out_date', 'Çıkış tarihi seçin');
            if (quickDatePicker) quickDatePicker.value = clickedDate.format('DD/MM/YYYY');

            applyMobileEndPhase(clickedDate);

            // Yumuşak scroll ile en erken seçilebilir çıkış ayına git
            const targetDate = minEndFor(clickedDate);
            const targetMonthElement = calendarContainer.querySelector(`.daire-detay-calendar-month[data-month="${targetDate.format('YYYY-MM')}"]`);

            if (targetMonthElement && scrollContainer) {
                setTimeout(function() {
                    const containerTop = scrollContainer.offsetTop;
                    const elementTop = targetMonthElement.offsetTop;
                    const scrollTo = elementTop - containerTop - 60; // 60px header için offset

                    scrollContainer.scrollTo({
                        top: scrollTo,
                        behavior: 'smooth'
                    });
                }, 300);
            }
        }

        applyMobileStartPhase();

        calendarContainer.addEventListener('click', function(e) {
            const dayCell = e.target.closest('.daire-detay-calendar-day');
            if (!dayCell || !dayCell.dataset.date) return;
            if (dayCell.classList.contains('disabled') || dayCell.classList.contains('temp-disabled')) return;

            const clickedDate = moment(dayCell.dataset.date, 'YYYY-MM-DD');
            const inStartWindow = !clickedDate.isAfter(startWindowMax, 'day');
            const pickingStart = !mobileSelectedStart
                || mobileSelectedEnd
                || (inStartWindow && clickedDate.isBefore(minEndFor(mobileSelectedStart), 'day'));

            if (pickingStart) {
                if (!inStartWindow) {
                    // Aralık tamamken giriş penceresi dışına tıklandı → sessizce baştan başla.
                    resetMobileSelection();
                    return;
                }
                startMobileSelection(dayCell, clickedDate);
                return;
            }

            // Çıkış seçimi — geçersiz günler temp-disabled olduğundan buraya yalnız geçerli
            // çıkışlar gelir; ek doğrulama/uyarı gerekmez.
            mobileSelectedEnd = clickedDate;
            selectedEnd = clickedDate;

            // Aralığı vurgula
            calendarContainer.querySelectorAll('.daire-detay-calendar-day').forEach(function(el){
                const d = moment(el.dataset.date, 'YYYY-MM-DD');
                el.classList.remove('range', 'range-start', 'range-end', 'selected');

                if (d.isSame(mobileSelectedStart, 'day')) {
                    el.classList.add('selected', 'range-start');
                } else if (d.isSame(mobileSelectedEnd, 'day')) {
                    el.classList.add('selected', 'range-end');
                } else if (d.isAfter(mobileSelectedStart) && d.isBefore(mobileSelectedEnd)) {
                    el.classList.add('range');
                }

                el.classList.remove('temp-disabled');
            });

            if (moveOutDisplay) moveOutDisplay.textContent = clickedDate.format('D MMM YYYY');
            if (quickDatePicker) quickDatePicker.value = mobileSelectedStart.format('DD/MM/YYYY') + ' - ' + mobileSelectedEnd.format('DD/MM/YYYY');
        });

        // reservation-button ile inputu güncelle
        const reservationBtn = document.querySelector('.reservation-button');
        if (reservationBtn) {
            reservationBtn.addEventListener('click', function () {
                if (mobileSelectedStart && mobileSelectedEnd && quickDatePicker) {
                    quickDatePicker.value = mobileSelectedStart.format('DD/MM/YYYY') + ' - ' + mobileSelectedEnd.format('DD/MM/YYYY');
                }
            });
        }

        return; // Mobilde Lightpick çalıştırma!
    }

    // DESKTOP: Lightpick entegrasyonu (eskisi gibi devam ediyor)
    
    // Giriş seçildikten sonraki "çıkış ayına git" geçişi; yeni seçim/sıfırlama bekleyen geçişi iptal eder.
    let navToken = 0;

    // Kayıtlı aralık bugünkü kurallarla hâlâ seçilebilir mi (giriş penceresi + süre sınırları)?
    function isBookableRange(start, end) {
        return start.isValid() && end.isValid()
            && !start.isBefore(reservationStartDate, 'day') && !start.isAfter(startWindowMax, 'day')
            && !end.isBefore(minEndFor(start), 'day') && !end.isAfter(start.clone().add(maxMonths, 'months'), 'day');
    }

    // Seçimi sıfırla ve takvimi seçilebilir giriş günlerinin olduğu aya götür.
    function resetDesktopSelection() {
        navToken++;
        selectedStart = null;
        selectedEnd = null;
        picker.setStartDate(null, true);
        picker.setEndDate(null, true);
        if (moveInDisplay) moveInDisplay.textContent = reservationCalendarText('select_calendar', 'Takvim seçin');
        if (moveOutDisplay) moveOutDisplay.textContent = reservationCalendarText('select_calendar', 'Takvim seçin');
        quickDatePicker.value = '';
        picker.gotoDate(reservationStartDate.toDate());
        const monthsContainer = calendarContainer.querySelector('.lightpick__months');
        if (monthsContainer) monthsContainer.style.opacity = '1';
        updateDisabledDates();
    }
    window.__resetDesktopReservation = resetDesktopSelection;

    // Modal açıldığında inputtaki tarih aralığını Lightpick'e aktar (/cart "Düzenle" ve ürün sayfası).
    // Aralık artık seçilemiyorsa (ör. sepetteki giriş, müsaitlik + 7 gün penceresinin dışında kaldıysa)
    // eski aralık yüklenmez: yüklenirse takvim seçilebilir günü olmayan aya açılıp ilk tıklamada takılıyordu.
    function setPickerFromInput() {
        if (!picker) return;
        // Tarih aralığı formatı: DD/MM/YYYY - DD/MM/YYYY (yalnız giriş seçiliyken Lightpick "DD/MM/YYYY - ..." yazar)
        const parts = (quickDatePicker.value || '').split(' - ');
        const start = moment(parts[0], 'DD/MM/YYYY', true);
        const end = parts.length === 2 ? moment(parts[1], 'DD/MM/YYYY', true) : moment.invalid();

        if (isBookableRange(start, end)) {
            if (selectedStart && selectedEnd && selectedStart.isSame(start, 'day') && selectedEnd.isSame(end, 'day')) {
                return; // zaten yüklü
            }
            navToken++;
            selectedStart = start;
            selectedEnd = end;
            picker.setStartDate(start.toDate(), true);
            picker.setEndDate(end.toDate(), true);
            if (moveInDisplay) moveInDisplay.textContent = start.format('D MMM YYYY');
            if (moveOutDisplay) moveOutDisplay.textContent = end.format('D MMM YYYY');
            picker.gotoDate(start.toDate());
            updateDisabledDates();
            return;
        }

        // Yarım seçim (yalnız giriş) sürüyorsa olduğu gibi bırak
        if (selectedStart && !selectedEnd && start.isValid() && start.isSame(selectedStart, 'day')) return;

        resetDesktopSelection();
    }

    // reservationCalendar modal açıldığında tetiklenir
    const reservationCalendarModal = document.getElementById('reservationCalendar');
    if (reservationCalendarModal) {
        reservationCalendarModal.addEventListener('show.bs.modal', function () {
            setTimeout(setPickerFromInput, 100); // Modal animasyonu için küçük gecikme
            setTimeout(setPickerFromInput, 350); // İkinci kez çağır, Lightpick render gecikmesi için
        });
    }

    function updateDisabledDates() {
        if (!picker || !picker.el) return;

        setTimeout(() => {
            const days = picker.el.querySelectorAll('.lightpick__day');
            days.forEach(dayElement => {
                const dayTime = parseInt(dayElement.getAttribute('data-time'));
                if (!dayTime) return;

                const dayDate = moment(dayTime);
                let shouldDisable = dayDate.isBefore(reservationStartDate, 'day') || dayDate.isAfter(reservationMaxDate, 'day');

                // Giriş seçiliyse +100 gün öncesi disabled olmalı
                if (!shouldDisable && selectedStart && !selectedEnd) {
                    const minEndDate = minEndFor(selectedStart);
                    const maxEndDate = moment(selectedStart).add(maxMonths, 'months');
                    shouldDisable = dayDate.isBefore(minEndDate, 'day') || dayDate.isAfter(maxEndDate, 'day');
                }

                // Giriş (start) seçerken: giriş yalnızca [müsaitlik, müsaitlik + 7 gün] aralığından
                if (!shouldDisable && !selectedStart) {
                    shouldDisable = dayDate.isAfter(startWindowMax, 'day');
                }

                if (shouldDisable) {
                    dayElement.classList.add('is-disabled');
                    dayElement.classList.remove('is-available');
                } else if (!dayElement.classList.contains('is-start-date') &&
                    !dayElement.classList.contains('is-previous-month') &&
                    !dayElement.classList.contains('is-next-month')) {
                    dayElement.classList.remove('is-disabled');
                    dayElement.classList.add('is-available');
                }
            });
        }, 50);
    }

    picker = new Lightpick({
        field: quickDatePicker,
        singleDate: false,
        numberOfMonths: 2,
        minDate: reservationStartDate.toDate(),
        maxDate: reservationMaxDate.toDate(),
        inline: true,
        autoclose: false,
        repick: false,
        lang: document.documentElement.lang || 'tr',
        parentEl: calendarContainer,
        disableDates: (date) => {
            const dateMoment = moment(date);

            if (dateMoment.isBefore(reservationStartDate, 'day') || dateMoment.isAfter(reservationMaxDate, 'day')) {
                return true;
            }

            // Giriş seçiliyse +100 gün öncesi disabled
            if (selectedStart && !selectedEnd) {
                const minEndDate = minEndFor(selectedStart);
                const maxEndDate = moment(selectedStart).add(maxMonths, 'months');
                return dateMoment.isBefore(minEndDate, 'day') || dateMoment.isAfter(maxEndDate, 'day');
            }

            // Giriş (start) seçerken: giriş yalnızca [müsaitlik, müsaitlik + 7 gün] aralığından
            if (!selectedStart) {
                return dateMoment.isAfter(startWindowMax, 'day');
            }

            return false;
        },
        onSelect: (start, end) => {
            // Sıfırlamadan sonra Lightpick'in boş bildirimi — yapılacak bir şey yok
            if (!start && !end) return;

            // Lightpick'in otomatik end seçimini engelle
            if (end && start) {
                const startJustSelected = !selectedStart || (selectedStart && !moment(start).isSame(selectedStart, 'day'));
                if (startJustSelected) {
                    setTimeout(() => {
                        picker.setEndDate(null, true);
                        selectedEnd = null;
                        // Bu arada seçim sıfırlandıysa "Çıkış tarihi seçin" yazma (yarım durum bırakıyordu)
                        if (selectedStart && moveOutDisplay) moveOutDisplay.textContent = reservationCalendarText('select_move_out_date', 'Çıkış tarihi seçin');
                    }, 0);
                    end = null;
                }
            }

            if (!end) {
                // Giriş tarihi seçimi
                if (selectedStart && selectedEnd) {
                    selectedStart = null;
                    selectedEnd = null;
                    picker.setStartDate(null, true);
                    picker.setEndDate(null, true);
                    if (moveOutDisplay) moveOutDisplay.textContent = reservationCalendarText('select_calendar', 'Takvim seçin');
                    if (moveInDisplay) moveInDisplay.textContent = reservationCalendarText('select_calendar', 'Takvim seçin');
                }

                if (selectedEnd) {
                    selectedEnd = null;
                    picker.setEndDate(null, true);
                    if (moveOutDisplay) moveOutDisplay.textContent = reservationCalendarText('select_move_out_date', 'Çıkış tarihi seçin');
                }

                // Aralık tamamken giriş penceresi (müsaitlik + 7 gün) dışına tıklandı →
                // uyarı göstermeden seçimi sıfırla; pencere dışı günler yeniden kapanır.
                // Takvim, seçilebilir giriş günlerinin olduğu aya döner (yoksa seçilebilir günü olmayan ayda kalıyordu).
                if (start && moment(start).isAfter(startWindowMax, 'day')) {
                    resetDesktopSelection();
                    return;
                }

                selectedStart = start ? moment(start) : null;
                selectedEnd = null;

                picker.setStartDate(start, true);
                picker.setEndDate(null, true);

                if (moveOutDisplay) moveOutDisplay.textContent = reservationCalendarText('select_move_out_date', 'Çıkış tarihi seçin');
                if (moveInDisplay) moveInDisplay.textContent = start ? moment(start).format('D MMM YYYY') : reservationCalendarText('select_calendar', 'Takvim seçin');

                // quickDatePicker inputuna giriş tarihini yaz (DD/MM/YYYY formatında)
                if (quickDatePicker) {
                    quickDatePicker.value = start ? moment(start).format('DD/MM/YYYY') : '';
                }

                // +100 gün sonraki tarihi hesapla
                const targetDate = minEndFor(moment(start)).toDate();

                // Disabled tarihleri güncelle
                setTimeout(() => {
                    updateDisabledDates();
                }, 100);

                // Takvimi en erken çıkış ayına tek geçişle götür. (Eskiden ay ay ~1,3 sn kayıyordu ve
                // Lightpick seçimi iki kez bildirdiği için iki animasyon üst üste biniyordu.)
                const token = ++navToken;
                const monthsContainer = calendarContainer.querySelector('.lightpick__months');
                if (monthsContainer) {
                    monthsContainer.style.transition = 'opacity 0.15s ease';
                    monthsContainer.style.opacity = '0.5';
                }
                setTimeout(() => {
                    if (token !== navToken) return; // bu arada yeni seçim / sıfırlama oldu
                    picker.gotoDate(targetDate);
                    updateDisabledDates();
                    const months = calendarContainer.querySelector('.lightpick__months');
                    if (months) months.style.opacity = '1';
                }, 150);

            } else {
                // Çıkış tarihi seçimi — geçersiz çıkışlar (tampon kuralı dahil) zaten
                // disableDates ile kapalı; ek doğrulama/uyarı gerekmez.
                selectedStart = moment(start);
                selectedEnd = moment(end);

                if (moveInDisplay) moveInDisplay.textContent = start ? moment(start).format('D MMM YYYY') : reservationCalendarText('select_calendar', 'Takvim seçin');
                if (moveOutDisplay) moveOutDisplay.textContent = end ? moment(end).format('D MMM YYYY') : reservationCalendarText('select_move_out_date', 'Çıkış tarihi seçin');

                // quickDatePicker inputuna tam tarih aralığını yaz (DD/MM/YYYY - DD/MM/YYYY formatında)
                if (quickDatePicker) {
                    quickDatePicker.value = `${moment(start).format('DD/MM/YYYY')} - ${moment(end).format('DD/MM/YYYY')}`;
                }

                updateDisabledDates();
            }
        }
    });

    // Takvimde aylar arası geçişte animasyon
    setTimeout(() => {
        if (picker && typeof picker.gotoDate === 'function') {
            picker.gotoDate(reservationStartDate.toDate());
            updateDisabledDates();
        }
    }, 50);

    setTimeout(() => {
        const monthsContainer = calendarContainer.querySelector('.lightpick__months');
        const prevButton = calendarContainer.querySelector('.lightpick__previous-action');
        const nextButton = calendarContainer.querySelector('.lightpick__next-action');

        if (prevButton && monthsContainer) {
            prevButton.addEventListener('click', () => {
                monthsContainer.style.transform = 'translateX(-20px)';
                monthsContainer.style.opacity = '0.5';
                setTimeout(() => {
                    monthsContainer.style.transform = 'translateX(0)';
                    monthsContainer.style.opacity = '1';
                    updateDisabledDates();
                }, 150);
            });
        }

        if (nextButton && monthsContainer) {
            nextButton.addEventListener('click', () => {
                monthsContainer.style.transform = 'translateX(20px)';
                monthsContainer.style.opacity = '0.5';
                setTimeout(() => {
                    monthsContainer.style.transform = 'translateX(0)';
                    monthsContainer.style.opacity = '1';
                    updateDisabledDates();
                }, 150);
            });
        }
    }, 100);
});

// Global fonksiyon: Takvimi temizle
window.clearPicker = function () {
    const moveInDisplay = document.getElementById('move-in-display');
    const moveOutDisplay = document.getElementById('move-out-display');
    const quickDatePicker = document.getElementById('quick-date-picker');
    const calendarContainer = document.getElementById('calendar-container');

    // Seçimleri sıfırla
    selectedStart = null;
    selectedEnd = null;

    if (isMobile()) {
        // Mobil takvimi temizle — giriş penceresi kısıtını (müsaitlik + 7 gün) yeniden uygula
        if (typeof window.__resetMobileReservation === 'function') {
            window.__resetMobileReservation();
        } else if (calendarContainer) {
            calendarContainer.querySelectorAll('.daire-detay-calendar-day.selected, .daire-detay-calendar-day.range, .daire-detay-calendar-day.temp-disabled, .daire-detay-calendar-day.range-start, .daire-detay-calendar-day.range-end').forEach(function(el){
                el.classList.remove('selected', 'range', 'temp-disabled', 'range-start', 'range-end');
            });
        }
    } else if (typeof window.__resetDesktopReservation === 'function') {
        // Masaüstü: giriş penceresi kısıtını (müsaitlik + 7 gün) koruyarak sıfırla
        window.__resetDesktopReservation();
    } else {
        const reservationWindow = getReservationWindow(12);
        const reservationStartDate = reservationWindow.startDate;
        const reservationMaxDate = reservationWindow.maxDate;
        // Desktop Picker'ı sıfırla
        if (picker) {
            picker.setStartDate(null, true);
            picker.setEndDate(null, true);

            // Takvimi bugüne (yarına) götür
            picker.gotoDate(reservationStartDate.toDate());
        }

        // Disabled günleri güncelle (tümü aktif olacak)
        setTimeout(() => {
            if (picker && picker.el) {
                const days = picker.el.querySelectorAll('.lightpick__day');
                days.forEach(dayElement => {
                    const dayTime = parseInt(dayElement.getAttribute('data-time'));
                    if (!dayTime) return;

                    const dayDate = moment(dayTime);
                    const shouldDisable = dayDate.isBefore(reservationStartDate, 'day') || dayDate.isAfter(reservationMaxDate, 'day');

                    if (shouldDisable) {
                        dayElement.classList.add('is-disabled');
                        dayElement.classList.remove('is-available');
                    } else if (!dayElement.classList.contains('is-previous-month') &&
                        !dayElement.classList.contains('is-next-month')) {
                        dayElement.classList.remove('is-disabled');
                        dayElement.classList.add('is-available');
                    }
                });
            }
        }, 100);
    }

    // Display'leri sıfırla
    if (moveInDisplay) moveInDisplay.textContent = reservationCalendarText('select_calendar', 'Takvim seçin');
    if (moveOutDisplay) moveOutDisplay.textContent = reservationCalendarText('select_calendar', 'Takvim seçin');

    // Input'u temizle
    if (quickDatePicker) quickDatePicker.value = '';
};

/* Ürün Detay Takvim Üstü Aylık Üçret ve Takvim otomasyonu sağ sol ok slider geçişleri */
document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        var inner = document.getElementById('dateScrollerInner');
        var leftBtn = document.getElementById('dateScrollerLeft');
        var rightBtn = document.getElementById('dateScrollerRight');
        if (!inner || !leftBtn || !rightBtn) return;
        
        var items = inner.querySelectorAll('.daire-detay-date-list__item');
        var gap = 20;
        var isDown = false;
        var startX;
        var scrollLeft;
        function getItemWidth() {
            if (items.length > 0) return items[0].offsetWidth;
            return 120;
        }
        function updateArrows() {
            var scrollLeftVal = inner.scrollLeft;
            var maxScroll = inner.scrollWidth - inner.clientWidth;
            // En baştaysa sol ok gizli
            if (scrollLeftVal <= 2) {
                leftBtn.style.visibility = 'hidden';
            } else {
                leftBtn.style.visibility = 'visible';
            }
            // En sondaysa sağ ok gizli
            if (scrollLeftVal >= maxScroll - 2) {
                rightBtn.style.visibility = 'hidden';
            } else {
                rightBtn.style.visibility = maxScroll > 0 ? 'visible' : 'hidden';
            }
        }
        leftBtn.addEventListener('click', function () {
            inner.scrollBy({ left: -(getItemWidth() + gap), behavior: 'smooth' });
            setTimeout(updateArrows, 300);
        });
        rightBtn.addEventListener('click', function () {
            inner.scrollBy({ left: getItemWidth() + gap, behavior: 'smooth' });
            setTimeout(updateArrows, 300);
        });
        inner.addEventListener('scroll', updateArrows);
        window.addEventListener('resize', updateArrows);
        // Başlangıçta en başa kaydır ve okları güncelle
        inner.scrollLeft = 0;
        setTimeout(updateArrows, 100);

        // Mouse ile sürükleme (gelişmiş)
        // Sürükleme deneyimini iyileştir (daha akıcı ve takılmasız)
        let dragStarted = false;
        let lastX = 0;
        let velocity = 0;
        let animationFrame;
        function onMouseMove(e) {
            if (!isDown) return;
            e.preventDefault();
            dragStarted = true;
            const x = e.pageX;
            const walk = (x - startX);
            inner.scrollLeft = scrollLeft - walk;
            velocity = x - lastX;
            lastX = x;
        }
        function onMouseUp() {
            if (isDown) {
                isDown = false;
                inner.classList.remove('dragging');
                document.body.style.userSelect = '';
                // Kinetik kaydırma efekti (inertia)
                if (dragStarted && Math.abs(velocity) > 1) {
                    let inertia = velocity;
                    function inertiaScroll() {
                        if (Math.abs(inertia) > 0.5) {
                            inner.scrollLeft -= inertia;
                            inertia *= 0.92;
                            animationFrame = requestAnimationFrame(inertiaScroll);
                        } else {
                            cancelAnimationFrame(animationFrame);
                        }
                    }
                    inertiaScroll();
                }
                dragStarted = false;
                velocity = 0;
            }
        }
        inner.addEventListener('mousedown', function (e) {
            if (e.button !== 0) return;
            isDown = true;
            dragStarted = false;
            inner.classList.add('dragging');
            startX = e.pageX;
            lastX = e.pageX;
            scrollLeft = inner.scrollLeft;
            document.body.style.userSelect = 'none';
        });
        inner.addEventListener('mouseleave', onMouseUp);
        inner.addEventListener('mouseup', onMouseUp);
        inner.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, 500);
});
